import FormValidation from "../../Validation/FormValidation";

const Checkbox = {

    bind(form) {
        this.input = 'input[type="checkbox"]';
        form.find(this.input).on('change', (evt) => {
            FormValidation.setValid($(evt.currentTarget), this.isValid($(evt.currentTarget)));
        });
    },

    check(form) {
        let ok = true;
        form.find(this.input).each((i, el) => {
            ok &= this.isValid($(el));
            FormValidation.setValid($(el),  this.isValid($(el)), true);
        })
        return ok;
    },

    isValid(input) {
        const isRequired = input.closest('.input').is('.required');

        if (isRequired) return input.prop('checked');
        else return true;

    },
}

export default Checkbox;
